import Box from '@zenbusiness/zui/Box';
import { styled } from '@zenbusiness/zui/styles';

export const GreenCircleStyle = ({ theme }) => ({
  backgroundColor: theme.palette.background.green.light,
  width: '32px',
  height: '32px',
  borderRadius: '100px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginRight: '16px',
  fontSize: '12px',
  fontWeight: 600
});

export const GridStyle = () => ({
  display: 'grid',
  marginBottom: '32px',
  alignItems: 'flex-start',
  gridTemplateColumns: '48px auto'
});

export const PaperStyle = () => ({
  padding: '24px',
  margin: '40px auto',
  '&.MuiPaper-rounded': {
    borderRadius: '18px'
  }
});

export const ContainerStyle = ({ theme }) => ({
  paddingBottom: '40px',
  display: 'grid',
  gridTemplateColumns: 'auto',
  margin: '30px auto',
  maxWidth: '1330px',
  columnGap: '120px',
  [theme.breakpoints.up('md')]: {
    gridTemplateColumns: '45% auto',
    paddingBottom: '0px'
  }
});

export const GreenCircle = styled(Box)(GreenCircleStyle);

export const GridStyled = styled(Box)(GridStyle);
